module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/day-rain-8acfb67fc932c44956624a4a915d1ce3.svg";